module.exports = __webpack_public_path__ + "static/media/menu_icon_interestcheck_hover.01772c65.png";